var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-video-player-box",
      style: { transform: `scale(${_vm.autoScale ? _vm.screenScale : 1})` },
    },
    [
      _vm.arena && !_vm.isEmpty(_vm.arena)
        ? _c(
            "div",
            { staticClass: "video-wrapper" },
            [
              _c("TCVideo"),
              _vm._l(_vm.arenaList, function (a) {
                return _c(
                  "button",
                  {
                    key: `arena-${a.id}`,
                    staticClass: "vjs-custom-arena-button-temp",
                    class: { active: _vm.arena.id === a.id },
                    on: {
                      click: function ($event) {
                        return _vm.arenaUpdateHandler(a)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          a.name[_vm.streamUrlSelector] || a.name.default
                        ) +
                        " "
                    ),
                  ]
                )
              }),
            ],
            2
          )
        : _c("div", { staticClass: "no-active-arena" }, [
            _c("img", {
              staticClass: "logo",
              attrs: { src: require("@/assets/images/alert.webp") },
            }),
            _c("div", { staticClass: "text" }, [
              _vm._v(" " + _vm._s(_vm.$t("No fight at the moment")) + " "),
            ]),
            _c("div", { staticClass: "text" }, [
              _vm._v(" " + _vm._s(_vm.$t("Please come back again")) + " "),
            ]),
          ]),
      _c(
        "div",
        { class: ["video-banner-wrapper", { "is-mobile": _vm.isMobile }] },
        [
          _c("div", { staticClass: "odds-wrapper" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("Banker")))]),
            _vm.autoScale && _vm.screenScale > 1
              ? _c("span", { staticClass: "ml-16 odds" }, [
                  _vm._v(_vm._s(_vm.bankerOdds)),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "odds-wrapper" }, [
            _vm.autoScale && _vm.screenScale > 1
              ? _c("span", { staticClass: "mr-16 odds" }, [
                  _vm._v(_vm._s(_vm.playerOdds)),
                ])
              : _vm._e(),
            _c("span", [_vm._v(_vm._s(_vm.$t("Player")))]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }